export var addRUMTiming = function addRUMTiming(timerName, startTimeInMs) {
  console.log('addRUMTiming', timerName);
  if (window && window.DD_RUM) {
    window.DD_RUM.onReady(function () {
      var timeInMs = startTimeInMs ? Date.now() - startTimeInMs : Date.now();
      window.DD_RUM.addTiming(timerName, timeInMs);
    });
  }
};